module.exports = __webpack_public_path__ + "img/copyright.60eed53b.svg";